import * as React from "react"
const SvgMail = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={40}
    height={40}
    fill="none"
    {...props}
  >
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M40 20c0 11.046-8.954 20-20 20S0 31.046 0 20 8.954 0 20 0s20 8.954 20 20m-29.682-9.643h19.364c1.662 0 3.014 1.299 3.014 2.895v13.497c0 1.595-1.352 2.894-3.014 2.894H10.318c-1.662 0-3.014-1.299-3.014-2.895V13.252c0-1.595 1.352-2.894 3.014-2.894m0 16.73h19.364c.244 0 .458-.158.459-.338V15.036l-8.758 7.394a1 1 0 0 1-.644.235H19.26a1 1 0 0 1-.643-.235L9.86 15.036V26.75c0 .18.214.338.458.338m1.164-14.175L20 20.128l8.518-7.216z"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgMail
